import { Box, Typography } from "@mui/material";
import React, { CSSProperties, useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";
import { SPColor } from "../../constants/color";
import { School, SchoolLeader } from "../../types/record";
import Loading from "../Loading/Loading";
import SPSelect from "../SPSelect/SPSelect";
import LeaderBoard from "./LeaderBoard";

type SchoolLeaderPageProp = {
  schools: School[];
};

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

export default function SchoolLeaderPage({ schools }: SchoolLeaderPageProp) {
  const [list, setList] = useState<SchoolLeader[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [schoolId, setSchoolId] = useState<string | number>("");

  useEffect(() => {
    if (schoolId) {
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}/api/class-leader/${schoolId}`)
        .then((response) => response.json())
        .then((data) => {
          const list = JSON.parse(data.data);
          setList(
            list.sort((a: SchoolLeader, b: SchoolLeader) =>
              a.place > b.place ? 1 : -1
            )
          );
          setLoading(false);
        });
    } else {
      setList([]);
    }
  }, [schoolId]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        margin: "auto",
        maxWidth: "md",
      }}
    >
      <Box sx={{ marginTop: 1, width: "100%" }}>
        {schools && (
          <SPSelect
            items={schools?.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
            onChange={(e: number | string) => setSchoolId(e)}
            defaultValue={schoolId}
            bgColor={SPColor.WHITE}
            sx={{
              borderColor: "black",
              width: "100%",
              "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
                {
                  padding: "4px 28px 4px 16px",
                  borderColor: SPColor.ORANGE + " !important",
                  borderWidth: "2px !important",
                  border: "solid",
                },
            }}
            placeholder="בחר בית ספר"
            name={"school"}
          />
        )}
      </Box>
      <Box>
        {list.map((item: SchoolLeader) => (
          <LeaderBoard item={item} key={item.id} type="school" />
        ))}
      </Box>
    </Box>
  );
}
